/* eslint-disable no-param-reassign */
import { Q } from '@nozbe/watermelondb'

import flatMap from 'lodash/flatMap'
import map from 'lodash/map'

import { getAllPriceData } from '@smartcoop/services/apis/smartcoopApi/resources/dairyFarm'

const PRICES_DATA_FIELDS = [
  'pricesDataId', 'dairyFarmId', 'price', 'manual', 'companyName', 'organizationId',
  'priceDate','monthlyIncome','userId','userStateRegistrationId','costBulkId','deletedAt','createdAt', 'updatedAt'
]

export function pricesDataService(database) {
  async function createOrUpdate(pricesData = []) {
    await database.write(async () => {
      const promises = pricesData.map((priceData) => async () => {
        const register = await database.get('pricesData')
          .query(Q.where('pricesDataId', priceData?.pricesDataId || priceData?.id))
          .fetch()

        if(register[0]) {
          map(register, (item) => {
            item.destroyPermanently()
          })
        }
        if(priceData?.deletedAt) {
          return
        }
        await database.get('pricesData').create((item) => {
          PRICES_DATA_FIELDS.forEach((field) => {
            if(field === 'pricesDataId') {
              item[field] = priceData?.pricesDataId || priceData?.id
            } else {
              item[field] = priceData[field]
            }
          })
        })
      })

      await Promise.all(promises.map((fn) => fn()))
    })
  }

  async function deletePriceDataById(pricesDataId) {
    await database.write(async () => {
      const register = await database.get('pricesData')
        .query(Q.where('pricesDataId', pricesDataId))
        .fetch()

      if (register[0]) {
        await register[0].markAsDeleted()
      }
    })
  }

  async function clearTable() {
    await database.write(async () => {
      await database.get('pricesData').query().destroyAllPermanently()
    })
  }

  async function findPriceDataById(pricesDataId) {
    return database
      .get('pricesData')
      .query(Q.where('pricesDataId', pricesDataId))
      .fetchOne()
  }

  function observePricesData(dairyFarmId = null) {
    const pricesDataCollection = database.collections.get('pricesData')

    return pricesDataCollection.query(
      Q.where('dairyFarmId', Q.eq(dairyFarmId))
    ).observe()
  }

  async function syncPricesData(params) {
    const { data: response } = await getAllPriceData(
      { ...params, limit: 999999 }
    )

    await createOrUpdate(flatMap(response, grouped => flatMap(grouped?.data, item => ({ ...item, dairyFarmId: grouped?.dairyFarmId }))))
  }

  return {
    createOrUpdate,
    clearTable,
    deletePriceDataById,
    findPriceDataById,
    observePricesData,
    syncPricesData
  }
}